import { PaginationFilter } from '@liveauctioneers/caterwaul-components/types/PaginationFilter';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';

import { SearchFollowSuggestions } from '@/components/SearchFollowSuggestions/SearchFollowSuggestions';
import useIsNarrowerThan from '@/hooks/useIsNarrowerThan';
import { useAppSelector } from '@/redux/hooks';
import {
    getTotalSavedSearches,
    isSavedSearchesLoading,
    savedSearchSearchesSelector,
} from '@/redux/modules/savedSearch';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { ManageSavedSearchFilter } from './components/ManageSavedSearchFilter';
import { ManageSavedSearchGrid } from './components/ManageSavedSearchGrid';

type Props = {
    filters: PaginationFilter;
    onSavedSearchRecentFilterChange: (filters: PaginationFilter) => void;
};

export const ManageSavedSearches = (props: Props) => {
    const { filters, onSavedSearchRecentFilterChange } = props;
    const isMobile = useIsNarrowerThan(769);
    const formatMessage = useAppFormatMessage();
    const isLoading = useAppSelector(isSavedSearchesLoading);
    const searches = useAppSelector(savedSearchSearchesSelector);
    const totalSavedSearchesCount = useAppSelector(getTotalSavedSearches);

    const preparedSavedSearchFilter = (
        <ManageSavedSearchFilter
            filters={filters}
            onFilterChange={onSavedSearchRecentFilterChange}
        />
    );

    return (
        <>
            {!isMobile && preparedSavedSearchFilter}
            <ManageSavedSearchGrid
                className="max-[560px]:mt-md mt-lg w-full max-w-full flex-[1_0_auto]"
                preparedSavedSearchFilter={preparedSavedSearchFilter}
                searches={searches}
            />

            {!isLoading && totalSavedSearchesCount === 0 && (
                <BodyPrimary className="my-lg text-center">
                    {formatMessage(['search_alerts', 'no_followed'])}
                </BodyPrimary>
            )}
            {totalSavedSearchesCount <= 0 && (
                <SearchFollowSuggestions
                    className="w-full [&>div[class*='altHeader']]:mx-0 [&>div[class*='altHeader']]:mb-[20px] [&>div[class*='altHeader']]:mt-0 [&>div[class*='side-scroller']]:w-full"
                    useAltHeader
                />
            )}
        </>
    );
};
